import { IHisInfoItemBehavior } from "./IHisInfoItemBehavior";
import { HisInformationItem } from "../..";
import { StringUtility } from "../../../system/StringUtility";
import { IHisInformationValue, HisInformationTextValue } from "../../HisInformationValue";
import { PtNameBehavior } from "./PtNameBehavior";

/** HIS項目患者氏名・姓を生成する */
export class PtNameSeiBehavior implements IHisInfoItemBehavior {
  private static readonly Key = "PT_NAME_SEI";
  
  getValue(hisInfoItems: HisInformationItem[]): IHisInformationValue {
    const itemValues =  hisInfoItems.filter(x => x.name === PtNameSeiBehavior.Key).map(x => x.value);
    const behavior = new PtNameBehavior();
    const values = behavior.getValue(hisInfoItems).data as string[];
    const sei = values.map(x => StringUtility.getTextBeforeSpace(x));
    const data = itemValues.length > 0 ? itemValues : sei;
    return new HisInformationTextValue(PtNameSeiBehavior.Key, data);
  }
}
